const TrackOrder = ({ ...props }) => {
    return (
        <svg
            width="24"
            height="16"
            viewBox="0 0 24 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M23.0109 10.3519C23.0109 10.3519 23.8243 8.1876 21.9329 6.8235C20.9259 6.09552 20.3449 6.21357 19.028 5.21014C17.7692 4.25262 17.4206 2.4753 16.4652 1.6883C14.2833 -0.0890137 3.33511 0.0815037 1.75356 0.429097C1.75356 0.429097 -0.0991218 12.4506 0.00416346 12.4637L3.22537 12.4702C3.12209 13.5524 3.29639 15.1198 5.21362 15.1198C7.70537 15.1198 7.99588 12.4243 7.99588 12.4243L14.4254 12.4178C14.4254 13.4868 14.8127 15.2051 16.6008 15.2051C18.9118 15.2051 19.4024 12.4965 19.4024 12.4965C19.4024 12.4965 22.7269 12.4571 22.8108 12.4571C23.3079 12.4637 23.4177 10.7585 23.0109 10.3519ZM16.2587 6.02993C16.0908 6.20701 10.6361 6.0365 10.6232 5.98403C10.4683 4.79041 10.7459 2.42939 10.9266 2.32446C11.1074 2.21297 14.1801 2.25232 14.8773 3.05244C15.568 3.83944 16.4717 5.79383 16.2587 6.02993Z"
                fill="#696158"
            />
        </svg>
    )
}

export default TrackOrder
